import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, SupplierInvoiceData, PatialDetail, CountData } from './types'

export const selectSupplierInvoiceListEvent = (state: RootState): Event =>
  state.supplierInvoiveReducer.listEvent

export const selectSupplierInvoiceList = (state: RootState): ListData => state.supplierInvoiveReducer.list

export const selectSupplierInvoiceActionEvent = (state: RootState): Event =>
  state.supplierInvoiveReducer.actionEvent

export const selectSupplierInvoiceDetail = (state: RootState): SupplierInvoiceData | undefined =>
  state.supplierInvoiveReducer.detail

export const selectSupplierInvoiceDetailEvent = (state: RootState): Event =>
  state.supplierInvoiveReducer.detailEvent

export const selectPaymentActionEvent = (state: RootState): Event =>
  state.supplierInvoiveReducer.paymentActionEvent

export const selectPartialDetail = (state: RootState): PatialDetail | undefined =>
  state.supplierInvoiveReducer.partialPaymentDetail

export const selectPartialDetailEvent = (state: RootState): Event =>
  state.supplierInvoiveReducer.partialPaymentEvent

export const selectInvoiceCountData = (state: RootState): CountData | undefined =>
  state.supplierInvoiveReducer.countData
